import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SwagPage from './pages/SwagPage';
import Page404 from './pages/Page404';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


function App() {
  useEffect(() => {
    const onScroll = () => {
      const reveals = document.querySelectorAll('.scroll-reveal');
      reveals.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          el.classList.add('revealed');
        }
      });
    };

    window.addEventListener('scroll', onScroll);
    onScroll(); // run once on load

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/swag" element={<SwagPage />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </>
  );
}

export default App;
